/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Sync_FailedInputs */

const en_queue_sos_sync_failed = /** @type {(inputs: Queue_Sos_Sync_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders not in Business Central`)
};

/**
* | output |
* | --- |
* | "Sales orders not in Business Central" |
*
* @param {Queue_Sos_Sync_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_sync_failed = /** @type {((inputs?: Queue_Sos_Sync_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Sync_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_sync_failed(inputs)
});